module.exports = __webpack_public_path__ + "open-sans-italic.1afd1d044d8ad47a0e7d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/google/open-sans-italic.woff
// module id = 705
// module chunks = 2